<template>
    <div class="responsive-nav visible-xs visible-sm" v-bind:class="{collapsed: collapsed}">
        <a v-if="collapsed" class="hamburger pull-right" v-on:click="toggleActive(!collapsed, false)">
            <font-awesome-icon :icon="getIcon" />
        </a>
        <a v-else class="hamburger pull-right" v-on:click="toggleActive(!collapsed, false)">
            <font-awesome-icon :icon="getIcon" />
        </a>
        <slot v-on:click="toggleActive(false, false)"></slot></div>
</template>

<script>

    export default {
        name: "ResponsiveNav.vue",
        data () {
            return {
                collapsed: true
            }
        },
        computed: {
            getIcon () {
                return this.collapsed ? 'bars' : 'times'
            }
        },
        methods: {
            toggleActive (flag, parent) {
                if(parent){
                    this.collapsed = !this.collapsed
                    return;
                }
                this.collapsed = flag
            }
        }
    }
</script>

<style scoped>
    .responsive-nav {
        position: absolute;
        top: 0;
        left: 0;
        background: #f8f8f8;
        transition: margin 0.2s ease-out;
        border: 1px solid #cccccc;
        z-index:2;
        padding-bottom: 20px;
    }
    .responsive-nav.collapsed {
        width: 250px;
        margin-left: -250px;
    }
    .responsive-nav li{
        width: 100%;
        text-align: center;
        border: 1px solid;
        margin: 5px;
        border-radius: 10px;
    }

    .responsive-nav li a{
        background: linear-gradient(1deg, #e2d1c3 0%, #fdfcfb 100%,#e2d1c3 0%);
        border-radius: 10px;
    }
    .hamburger {
        display: block;
        height: 30px;
        width: 30px;
        padding: 15px;
        text-align: center;
        position: relative;
        left: -20px;
    }
    .responsive-nav.collapsed .hamburger {
        left: 30px;
    }
    .svg-inline--fa{
    font-size: 1.5em;
    }
</style>